/* import __COLOCATED_TEMPLATE__ from './manage-watchers.hbs'; */
import { allSettled } from 'rsvp';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { sort, readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import StateManagerMixin from 'sh-www/mixins/state-manager-mixin';
import { closeModal } from 'sh-www/utils/modal-controls';

export default Component.extend(StateManagerMixin, {
  tagName: '',

  elementRef: null,

  // States
  awaitingResponse: undefined,

  // State Service Default Updates
  stateServiceProperties: 'awaitingResponse',

  // Expects
  colleaguesListSortCriteria: ['fullName'],
  colleaguesListSorted: sort('model.colleaguesList', 'colleaguesListSortCriteria'),

  /**
   * The buyer id that created this thread.
   *
   * @type {Number|null}
   */
  threadMainBuyerId: computed('model.threadToWatch.etc.relationships.users', function() {
    const threadUsers = this.model.threadToWatch.etc.relationships.users;
    let mainBuyerId = null;

    threadUsers.forEach((threadUser) => {
      if (threadUser.role === 'buyer') {
        mainBuyerId = threadUser.user_id.toString();
      }
    });

    return mainBuyerId;
  }),

  threadWatcherIds: undefined,

  store: service(),
  CEW: service('customEndpointWrapper'),
  threadManager: service('managers/threadManager'),
  session: service(),

  currentUser: readOnly('session.currentUser'),

  actions: {
    elementCallback(element) {
      this.set('elementRef', element);
    },
    cancelSpeedSearch() {
    },
    saveWatchers() {
      this._setWatchers.bind(this)();
    },
    closeModal() {
      closeModal(this);
    },
  },

  _findWatcherIds() {
    const thread = this.model.threadToWatch;
    let watchedBy = thread.get('watchedBy');

    let colleagueIds = new Set(this.model.colleaguesList.getEach('id'));
    let usableWatcherIds = new Set();

    // We need to compare the watchedBy attribute with the current set
    // of colleague IDs so we don't accidentally remove legacy watchers
    // who are no longer part of the company (just for consistency's sake)

    watchedBy.forEach(watcherId => {
      if(colleagueIds.has(watcherId)) {
        usableWatcherIds.add(watcherId);
      }
    });

    this.set('threadWatcherIds', usableWatcherIds);
  },

  _setWatchers() {
    const thread = this.model.threadToWatch;
    let selectedColleagues = this.elementRef.querySelectorAll('.member-item input:checked');
    let threadWatcherIds = this.get('threadWatcherIds');
    let usersToAdd = new Set();
    let CEW = this.get('CEW');
    let threadManager = this.get('threadManager');

    selectedColleagues.forEach(function(element) {
      let colleagueId = element.getAttribute('name').toString();

      // The Set of Watchers to be removed is tracked here by examining the threadWatcherIds Set, and seeing
      // who was already a Watcher before the modal was interacted with.  By deleting each 'selected' Colleague
      // from the Set, we'll effectively be left with the users who weren't selected in the modal but were
      // Watchers at startup.  This is the list of people we'll need to call removeWatchers() on.

      if (threadWatcherIds.has(colleagueId)) {
        threadWatcherIds.delete(colleagueId);
      } else {
        usersToAdd.add(colleagueId);
      }
    });

    this.set('awaitingResponse', true);
    let promises = A();

    if(threadWatcherIds.size > 0) {
      let usersToRemoveData = this._buildUserData(threadWatcherIds);
      let removePromise = thread.removeUsers(CEW.format(usersToRemoveData));
      promises.pushObject(removePromise);
    }

    if(usersToAdd.size > 0 ) {
      let usersToAddData = this._buildUserData(usersToAdd);
      let addPromise = thread.addUsers(CEW.format(usersToAddData));
      promises.pushObject(addPromise);
    }

    allSettled(promises).then(responseArray => {
      let hasErrors = false;

      responseArray.forEach(response => {
        if(response.state !== 'fulfilled') {
          // Something wrong happened with this particular promise.  Do something
          hasErrors = true;
        }
      });

      if(!hasErrors) {
        let store = this.get('store');

        threadWatcherIds.forEach(userId => {
          threadManager.removeThreadWatcherAndSyncMeta(thread, store.peekRecord('user', userId));
        });

        usersToAdd.forEach(userId => {
          threadManager.addThreadWatcherAndSyncMeta(thread, store.peekRecord('user', userId));
        });

        if(this.get('isDestroyed') || this.get('isDestroying')) {
          this._MIX_updateState('awaitingResponse', false);
          return;
        }

        this.set('awaitingResponse', false);

        closeModal(this);
      }
    });

  },

  _buildUserData(set) {
    let userData = A();

    set.forEach(id => {
      userData.pushObject({
        id: id,
        type: 'user',
        role: 'watcher'
      });
    });

    return userData;
  },

  init() {
    this._super(...arguments);

    this._findWatcherIds.bind(this)();
  },

  willDestroy() {
    this.set('threadWatcherIds', undefined);
  }




});
